import styled, { css } from 'styled-components';
import { theme } from '../../../theme';

const { colors } = theme;

export const DivThumbnail = styled.div<{ image: string; isReview?: boolean }>`
  display: block;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  border: 0.3px solid ${colors.line};
  border-radius: 0.385rem;
  overflow: hidden;
  min-width: 2.385rem;
  min-height: 2.385rem;
  width: 2.385rem;
  height: 2.385rem;

  ${(props) =>
    props.image &&
    css`
      background-image: url('${props.image}');
    `}

  ${(props) =>
    props.isReview &&
    css`
      cursor: pointer;
    `}
  
  &.modal-title {
    width: 3rem;
    height: 3rem;
    margin-right: 1rem;
  }
`;
